import { useState } from 'react'
import classNames from 'classnames'
import { array, bool, number, string } from 'prop-types'
import { Icon } from '@winnin/winnin_ui.components.icon'

import CountryGraph from 'components/CountryGraph'
import './index.scss'

const CountryGraphPaginated = ({ count, paginated, className, width, height, countries: allCountries }) => {
  const filteredCountries = allCountries?.filter(v => v?.percent > 0) || []
  const othersTotalPercent = filteredCountries
    .map(v => v.percent)
    .filter(v => v < 0.01)
    .reduce((acc, v) => acc + v, 0)
  const countriesWithPercent = filteredCountries.filter(v => v.percent >= 0.01)
  const countries =
    othersTotalPercent > 0
      ? countriesWithPercent.concat([
          {
            country: 'other',
            percent: othersTotalPercent,
          },
        ])
      : filteredCountries

  const [page, setPage] = useState(1)
  const minPages = 1
  const maxPages = Math.ceil(countries.length / count)
  const showPagination = paginated && countries.length > count
  const hasPrevious = page > minPages
  const hasNext = page < maxPages

  const getData = () => {
    if (!paginated || !countries?.length) return countries

    const sliced = countries.slice((page - 1) * count, page * count)
    if (sliced.length < count) return sliced.concat(new Array(count - sliced.length))
    return sliced
  }

  const changePage = number => {
    if (number > maxPages || number < minPages) return null
    setPage(number)
  }

  const handlePreviousClick = () => {
    changePage(page - 1)
  }

  const handleNextClick = () => {
    changePage(page + 1)
  }

  const graphLegend = `${(page - 1) * count + 1} - ${
    page * count > countries.length ? countries.length : page * count
  } of ${countries.length}`

  return (
    <div className={classNames('country-graph-paginated', className)}>
      {countries.length > 0 && (
        <CountryGraph
          countries={getData()}
          className="paginated-country-graph"
          width={width}
          maxCount={count}
          maxValue={Number((Math.max(...countries.map(v => v.percent)) * 1.2).toFixed(2))}
          height={height}
        />
      )}
      {showPagination && (
        <div className="paginated-country-graph-paginated">
          {graphLegend}
          <button className="previous" onClick={handlePreviousClick} disabled={!hasPrevious}>
            <Icon className="arrow-icon" icon="arrowLeft" />
          </button>

          <button className="next" onClick={handleNextClick} disabled={!hasNext}>
            <Icon className="arrow-icon" icon="arrowRight" />
          </button>
        </div>
      )}
    </div>
  )
}

CountryGraphPaginated.propTypes = {
  count: number,
  paginated: bool,
  className: string,
  width: number,
  height: number,
  countries: array.isRequired,
}

export default CountryGraphPaginated
